import React, { Fragment, useMemo, useState } from "react";
import startCase from "lodash/startCase";
import { Button } from "torque-ui/components/Button";
import { AutocorpLogo } from "@/components/AutocorpLogo";
import { HANDOFF_METHODS } from "@/api/constants";
import SmartphoneVibrateIcon from "@assets/svg/smartphone-vibrate-icon.svg";
import EmailSentIcon from "@assets/svg/email-sent-icon.svg";

import { useStore } from "@/store";
import QrCode from "@/components/QRCode";

export default function CheckYourPhone() {
  const [showQR, setShowQR] = useState(false);
  const {
    state: {
      handoffMethod,
    },
    // actions: {
    //   setHandoffMethod,
    // }
  } = useStore();
  const [method] = useState(handoffMethod);

  const content = useMemo(() => ({
    title: method === HANDOFF_METHODS.EMAIL ? startCase(method) : `${startCase(method)} Number`,
    icon: method === HANDOFF_METHODS.EMAIL ? <EmailSentIcon width={80} /> : <SmartphoneVibrateIcon width={80} />,
  }), [method]);

  if (showQR) {
    return <QrCode />
  }

  return (
    <div className="h-full pb-12 flex flex-col bg-white" style={{ height: "100%" }}>
        <main className="flex-grow flex flex-col justify-center max-w-xs w-full mx-auto px-4">
          <div className="pb-8">
            <div className="text-center">
              <h1 className="mt-10 text-xl font-semibold text-gray-900 tracking-tight">{`Check Your ${content.title}`}</h1>

              <div className="w-full my-8 flex-shrink-0 flex justify-center">
                {content.icon}
              </div>

              <p className="my-4 text-base">
                We've sent a link to your phone via SMS.
              </p>
              <p className="my-4 text-base">
                Click on the link to use your phone to scan your ID.
              </p>
              <p className="my-4 text-base">
                When you're finished, return here.
              </p>

              <hr />

              <h1 className="mt-10 mb-6 text-xl font-semibold text-gray-900 tracking-tight">Having trouble?</h1>
              <Button
                className="rounded-full px-[20px]"
                onClick={() => {
                  console.log("use qr code!");
                  setShowQR(true);
                }}
              >
                Use a QR code instead
              </Button>
              {/* <a
                className="flex w-fit text-xs text-blue-700 no-underline cursor-pointer my-6 mx-auto"
                onClick={() => {
                  router.push("/id/mobile-handoff");
                  setHandoffMethod(
                    method === HANDOFF_METHODS.EMAIL
                      ? HANDOFF_METHODS.PHONE
                      : HANDOFF_METHODS.EMAIL
                  );
                }}
              >
                {`Send ${method === HANDOFF_METHODS.EMAIL ? "a link to my phone number" : "me an email"} instead`}
              </a> */}

              <p className="mt-8 text-sm">
                By using this service you agree to Autocorp's <a
                  href="https://www.autocorp.ai/terms-of-service"
                  target="_blank"
                  className=""
                >Terms of Services</a> and <a
                  href="https://www.autocorp.ai/privacy-policy"
                  target="_blank"
                  className=""
                >Privacy Policy</a>
              </p>
            </div>
          </div>
        </main>

        <footer className="flex-shrink-0 max-w-7xl w-full mx-auto px-4">
          <nav className="flex justify-center space-x-4">
            <AutocorpLogo />
          </nav>
        </footer>
      </div>
  );
}